(function () {
    'use strict';

    angular.module("imApp").factory("bankReconciliationsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3393,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
